import { cooKeys, customEvent, HackleEventName, setCookie } from "goi_common";

import { kakaoAuthorizeUrl } from "@/hooks/useKakaoLogin";

import { allowIntentionalLeave } from "../hooks/useParlorRouterChangeLoad";

export type E5ReceiveMethod = "kakao" | "nokakao";

/** 로그인 뒤 돌아갈 곳 · 가입 이벤트 출처. 기존 제출이 로그인 화면에 넘기던 값과 같다 */
const REDIRECT_TO = "/match/request/";
const EVENT_FROM = "uv_parlor_mtch_rqst";

/**
 * 받는 방법 버튼을 누른 순간의 이벤트.
 * 카카오는 로그인 화면을 건너뛰므로 로그인 화면 카카오 버튼과 같은 이벤트(login kakao_start + Hackle 「로그인/회원가입 클릭」)를
 * 여기서 쏜다(useCostLeadSubmit 과 같은 방식). 이미 로그인한 사람은 로그인을 거치지 않으니 로그인 이벤트는 쏘지 않는다
 */
export const fireE5ReceiveClick = (method: E5ReceiveMethod, isLoggedIn: boolean) => {
  customEvent({
    newGtm: {
      path: "parlor_match_request",
      trigger_and_target: method === "kakao" ? "e5_kakao" : "e5_nokakao",
    },
  });
  if (method === "kakao" && !isLoggedIn) {
    customEvent({
      newGtm: { path: "login", trigger_and_target: "kakao_start-kakao_login" },
      hackle: { key: HackleEventName["로그인/회원가입 클릭"] },
    });
  }
};

/**
 * 견적 저장이 끝난 뒤 받는 방법으로 보낸다.
 * - 카카오: 로그인 화면을 거치지 않고 카카오 인증으로. 돌아오면 로그인 화면이 기존처럼 결과로 넘긴다
 * - 카카오톡 없이: 로그인 화면의 번호 입력 창을 바로 연다(?nokakao=1)
 */
export const goE5Receive = (method: E5ReceiveMethod) => {
  setCookie(cooKeys.kakao_redirect, REDIRECT_TO);
  setCookie(cooKeys.event_from, EVENT_FROM);
  allowIntentionalLeave();
  if (method === "kakao") {
    location.href = kakaoAuthorizeUrl();
    return;
  }
  location.href = `/login?redirectTo=${encodeURIComponent(
    REDIRECT_TO,
  )}&event_from=${EVENT_FROM}&nokakao=1`;
};
